// entry file for @wordpress/scripts build processes

import "./scss/style.scss";
import "./js/nav.js";
import "./js/slider.js";
import "./js/faq.js";

addEventListener("DOMContentLoaded", (event) => { console.log('WJHuff JS loaded.'); });